export default __webpack_public_path__ + "static/media/envelop.d9704172.svg";